import { useEffect, useState } from 'react'

function Delayed ({ waitBeforeShow, children }) {
  const [hidden, setHidden] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setHidden(false)
    }, waitBeforeShow)
  }, [])

  return hidden ? '' : children
}

export default Delayed
